import { useFormikContext } from 'formik';
import * as React from 'react';
import { useState } from 'react';
import { Formatters, Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import WebHttpClient from '../../../../httpClient/WebHttpClient';
import { GetTotalRefreshTokenCountRequest, IGetTokenResult } from '../../../../ts/ServerApi/requests/GetTotalRefreshTokenCountRequest';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { warningText } from '../../../styles/CommonStyles';
import { ServerSettingsProps } from '../server-settings/ReactServerSettings';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export const CONNECTED_CLIENTS_FIELD = 'settings.refreshTokenEnabled';

export type ConnectedClientsSettingSectionProps = ServerSettingsProps<'refreshTokenEnabled'>;
interface ClientNumber {
  TOKEN_COUNT: number;
  TOKEN_COUNT_LOC: string;
}

const initializedClientNumber: ClientNumber =  {
  TOKEN_COUNT: 0,
  TOKEN_COUNT_LOC: null
};

export function ConnectedClientsSettingSection(props: ConnectedClientsSettingSectionProps) {
  const formik = useFormikContext<ConnectedClientsSettingSectionProps>();
  const initialValue = formik.initialValues.settings.refreshTokenEnabled;
  const currentValue = formik.values.settings.refreshTokenEnabled;
  const [totalRefreshTokenCount, setTotalRefreshTokenCount] = useState(initializedClientNumber);
  React.useEffect(() => {
    let clientNumber = initializedClientNumber;
    WebHttpClient.sendRequest(new GetTotalRefreshTokenCountRequest({}))
    .then((result: IGetTokenResult) => {
      clientNumber.TOKEN_COUNT = result.refreshTokenCount;
      clientNumber.TOKEN_COUNT_LOC = Formatters.formatCount(result.refreshTokenCount);
    });
    setTotalRefreshTokenCount(clientNumber);
  }, [totalRefreshTokenCount]);

  return <SettingsSection title={Messages.serverConnectedDevices()}
                       testId={'connected-devices-setting-section'}
                       description={Messages.serverConnectedDevicesDetails()}>
            <FormikCheckbox name={CONNECTED_CLIENTS_FIELD}
                            label={Messages.serverConnectedDevicesChecked()}
                            testId={'connected-devices-enabled'}>
            </FormikCheckbox>
            {initialValue && !currentValue && totalRefreshTokenCount.TOKEN_COUNT > 0 &&
              <div className={warningText} data-tb-test-id='connected-devices-warning'>
                {Messages.serverConnectedDevicesUncheckedWithCount(totalRefreshTokenCount)}
              </div>}
  </SettingsSection>;
}

export const ConnectedClientsSettingSectionSpecs = componentRegistryEntry({
  name: 'ConnectedClientsSettingSection',
  component: ConnectedClientsSettingSection
});
